<main>
  <div class="d-grid gap-4 faq-category-page">
    <div class="eventType-head flex-wrap gap-2">
      <div
        class="d-flex align-items-center gap-3"
        style="cursor: pointer"
        (click)="goBack()"
      >
        <i class="fas fa-arrow-left back-icon"></i>
        <div class="eventType-text">Work experience type</div>
      </div>
      <app-button
        label="Add work experience type"
        *ngIf="userRoles.addNew"
        [minWidth]="'17.5rem'"
        (clicked)="openAddCategory()"
      >
      </app-button>
    </div>

    <div
      *ngIf="!isLoading && filteredEventCategories.length === 0"
      class="faq-card"
    >
      <div class="pb-3">
        <div class="empty-state">
          <i class="far fa-file-alt"></i>
          <h4>No work experience types found</h4>
        </div>
      </div>
    </div>

    <div class="max-content">
      <div
        *ngFor="let category of filteredEventCategories; let i = index"
        class="faq-card"
        [class.faq-card-expanded]="category.isOpen"
      >
        <div class="grid-section">
          <div class="d-grid gap-2">
            <div class="header-text">
              {{ category.typeName }}
            </div>
            <div class="des-text">
              {{ category.description }}
            </div>
          </div>

          <div class="d-flex align-items-center" style="gap: 3rem">
            <div
              (click)="statusUpdate(category)"
              [ngClass]="
                category.isActive ? 'status-active' : 'status-inactive'
              "
            >
              {{ category.isActive ? "Active" : "Inactive" }}
            </div>

            <div class="d-flex align-items-center gap-3">
              <button
                class="edit-btn"
                *ngIf="userRoles.listItem.edit"
                title="Edit"
                (click)="editCategory(category)"
              >
                <img
                  class="action-button"
                  src="assets/images/Buttons/edit-button.svg"
                  alt="Edit"
                />
              </button>

              <button
                class="delete-btn"
                *ngIf="userRoles.listItem.delete"
                title="Delete"
                (click)="deleteCategory(category.id)"
              >
                <img
                  class="action-button"
                  src="assets/images/Buttons/delete-button.svg"
                  alt="Delete"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
